import { useEffect, useState, useRef } from "react"
import cx from "classnames"
import groupBySong from "../../shared/utils/songNormalizer"
import SongItemBeta from "../../shared/components/SongItemBeta"

const SongVersionsContainer = ({ container = "mm-song-versions-container" }) => {
  const el = document.getElementById(container)
  const songVersionsData = el && el.getAttribute("data-song-versions")
  const user_role = el && el.getAttribute("data-user-role")
  const [songVersions, setSongVersions] = useState([])
  const [expandedSongVersionId, setExpandedSongVersionId] = useState(false)
  const thisContainerRef = useRef(null)
  const handleSetExpandedSongVersionId = (svid) => {
    setExpandedSongVersionId(svid)
  }

  useEffect(() => {
    // Allows the component to react to DOM changes triggered by pagination
    const updateData = () => {
      const updatedData = el && el.getAttribute("data-song-versions")
      if (updatedData) {
        const parsed = JSON.parse(updatedData)
        const normalized = groupBySong(parsed)
        setSongVersions(normalized)
      }
    }
  
    updateData() 
  
    if (el) {
      el.addEventListener("data-updated", updateData)
    }
  
    return () => {
      if (el) {
        el.removeEventListener("data-updated", updateData)
      }
    }
  }, [])
  

  const songVersionProps = {
    song_versions_count: 1,
    user_role,
    handleSetExpandedSongVersionId,
    expandedSongVersionId,
  }

  return (
    //Done loading, also there are songs
    <div id="mm-song-versions" ref={thisContainerRef}>
      <article id="mm-song-versions-listing" aria-label="Songs listing">
        <div className="mm-song-versions-table" data-title="Search results">
          <ol className={cx("mm-song-versions-table-list")}>
            <li className="mm-song-versions-table-head">
              <ol>
                <li className="song-version">Song / Artist</li>
                <li className="versions desktop hidden">Versions</li>
                <li className="genres desktop">Genres</li>
                <li className="arc desktop">Arc&trade;</li>
                <li className="energy desktop" data-touch>
                  Energy
                </li>
                <li className="length">Length</li>
              </ol>
            </li>
            {songVersions.map((song) => (
              <SongItemBeta song={song} {...songVersionProps} key={song.songVersions[0].id} />
            ))}
          </ol>
        </div>
      </article>
    </div>
  )
}

export default SongVersionsContainer
